import { initSingleCalendar } from '../../components/calendars/singleCalendar';
import { initGlobalCalendar } from '../../components/calendars/globalCalendar';

$(document).on('ready turbolinks:load', function() {
  const singleCalendarEl = document.getElementById('calendar');
  const globalCalendarEl = document.getElementById('global-calendar');
  if (singleCalendarEl || globalCalendarEl) {
    const calendar = singleCalendarEl ? initSingleCalendar(singleCalendarEl) : initGlobalCalendar(globalCalendarEl);
    calendar.render();
    const $body = $('body');

    $body.on('eventAdded', (event, eventObj) => {
      event = JSON.parse(eventObj)
      calendar.addEvent(event)
    })

    $body.on('eventUpdated', (event, eventObj) => {
      let newEvent = JSON.parse(eventObj)
      let oldEvent = calendar.getEventById(newEvent.id)
      oldEvent && oldEvent.remove()
      calendar.addEvent(newEvent)
    })

    $body.on('eventRemoved', (event, eventId) => {
      const domEvent = calendar.getEventById(eventId);
      domEvent && domEvent.remove();
    })

    $body.on('click','.fc-next-button, .fc-prev-button', () => {
      const events = calendar.getEvents();
      calendar.getEvents().forEach(event => {
        event.remove();
      });
    })

    $(document).on('turbolinks:before-cache', () => {
      const calendarEl = singleCalendarEl || globalCalendarEl;
      if (!calendarEl) return;

      calendarEl.innerHTML = '';
      calendar.destroy();
    });
  }
});
